function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Add } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom/dist/Button";
import { Flex } from "sprout-ui-primitives";
import { PopoverReference, PopoverTrigger } from "sprout-ui-dom/dist/Popover";
import { LabelNewPopoverDialog } from "@sprout/client-components/dist/PopoverDialog";
import { usePopoverDialogState } from "sprout-ui-dom/dist/PopoverDialog";
import TopicPageAppBarMobile from "../TopicPageAppBarMobile";
const TopicPageViewsLabelsAppBarMobile = (props)=>{
    const { rootTopicId  } = props;
    const popoverDialogState = usePopoverDialogState();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageAppBarMobile, {
                children: /*#__PURE__*/ _jsx(Flex, {
                    mr: -2,
                    children: /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, popoverDialogState, {
                        children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, popoverDialogState, {
                            children: /*#__PURE__*/ _jsx(Button, {
                                variant: "circle",
                                children: /*#__PURE__*/ _jsx(Add, {})
                            })
                        }))
                    }))
                })
            }),
            /*#__PURE__*/ _jsx(LabelNewPopoverDialog, _objectSpread({
                rootTopicId: rootTopicId
            }, popoverDialogState))
        ]
    });
};
export default TopicPageViewsLabelsAppBarMobile;
